import React, { useEffect, useState} from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';
import { ToastContainer } from 'react-toastify';
import { changedPicture } from '../../Actions/changePic';
import { setLoading } from '../../Actions/setLoading';
import { uploadImage } from '../../Services/transferData';
import FormImage from '../common/FormImage';
import { paramsOfTextureViaQueryAction } from '../../Actions/paramsOfTextureAction';

const UploadImage = () => {
    const [queryParams,setQueryParams] = useState(null);
    const [location,setLocation] = useState();
    const Redirect = useNavigate();
    const dispatch = useDispatch();
    const [selectedImage, setSelectedImage] = useState(null);
    const handlePredefinedImageClick = (imageIndex) => {
        const predefinedImageSrc = `../assets/images/sample-img/${imageIndex}.jpg`;
        setSelectedImage(predefinedImageSrc);
    };

    useEffect(() => {
        import('../../utils/utils' /*webpackChunkName: "utils" */).then(({getQueryParams,getLocation}) => {
            setQueryParams(getQueryParams());
            setLocation(getLocation());
        })
    },[]);


    // TODO: send sample photo to server function
    const handleSampleImage = async (uniqeId) => {
        dispatch(setLoading());
        const formData = new FormData();
        formData.append('default_img',uniqeId);//uniqeId = pic-1 || pic-2 | ...
        formData.append('location',JSON.stringify(location));
        try {
            const {data,status} = await uploadImage(formData);
            if (status === 200) {
                dispatch(setLoading());
                dispatch(changedPicture(data.data));
                if(queryParams && queryParams.query_string_procode !== null) dispatch(paramsOfTextureViaQueryAction(queryParams.query_string_procode))
                if (window.innerWidth > 800) {
                    Redirect('/ariis-w');
                }else{
                    Redirect('/ariis-m');
                }
            }
        } catch (error) {
            setTimeout(() => {dispatch(setLoading())} ,1000)
        }
    }


    return ( 
        <>
            <div className='Home-upload text-right mx-auto'>
                <div className='form-group w-100'>
                    <div className='w-50 text-center upload-descktop'>
                        <label htmlFor="file-input">
                            <img src='../assets/images/Frame 1493.png' alt=''/>
                        </label>
                    </div>
                    <div className='w-50 text-center' onClick={e => handlePredefinedImageClick(1)}>
                        <img src='../assets/images/sample-img/1.jpg' alt='sample-image1' style={{height:'280px',maxWidth:"550px" }}/>
                        <p className='caption'  >محیط پیشفرض 1</p>
                    </div>
                    <div className='w-50 text-center' onClick={e => handlePredefinedImageClick(2)}>
                        <img src='../assets/images/sample-img/2.jpg' alt='sample-image2' style={{height:'280px',maxWidth:"550px" }}/>
                        <p className='caption' >محیط پیشفرض 2</p>
                    </div>
                    <div className='w-50 text-center' onClick={e => handlePredefinedImageClick(3)}>
                        <img src='../assets/images/sample-img/3.jpg' alt='sample-image3' style={{ height:'280px',maxWidth:"550px" }}/>
                        <p className='caption' >محیط پیشفرض 3</p>
                    </div>
                    <div className='w-50 text-center' onClick={e => handlePredefinedImageClick(4)}>
                        <img src='../assets/images/sample-img/4.jpg' alt='sample-image4' style={{ height:'280px',maxWidth:"550px" }}/>
                        <p className='caption' >محیط پیشفرض 4</p>
                    </div>
                    <div className='w-50 text-center' onClick={e => handlePredefinedImageClick(5)}>
                        <img src='../assets/images/sample-img/5.jpg' alt='sample-image5' style={{height:'280px',maxWidth:"550px" }}/>
                        <p className='caption' >محیط پیشفرض 5</p>
                    </div>
                </div>
            </div>

            <div className='mx-auto text-white upload-mobile'>
                <label htmlFor="file-input" >
                    <span className='d-inline-block' style={{transform: "translate(0px, 15px)"}}><i className='fa fa-camera pe-2'></i>انتخاب تصویر از دوربین یا گالری</span>
                </label>
            </div>


            <FormImage queryParams={queryParams} location={location} selectedImage={selectedImage} />
            <ToastContainer/>
        </>
    );
}
export default UploadImage;